import { Step1ChapterId } from './step1CoverageTopics';
import { t } from '../i18n/translate';

export interface LifeStoryPrompt {
  id: string;
  chapterId: Step1ChapterId;
  coverageTopicIds: string[];
  /** True when the prompt has an extra hint line (step.1.prompts.<id>.nudge) */
  hasNudge?: boolean;
}

export const STEP1_LIFE_STORY_PROMPTS: LifeStoryPrompt[] = [
  { id: 'intro_name', chapterId: 'ch1', coverageTopicIds: ['introduction'] },
  { id: 'family_overview', chapterId: 'ch2', coverageTopicIds: ['family_origin'], hasNudge: true },
  {
    id: 'family_sex_attitudes',
    chapterId: 'ch2',
    coverageTopicIds: ['family_origin', 'childhood_sexuality'],
    hasNudge: true,
  },
  { id: 'addiction_start', chapterId: 'ch3', coverageTopicIds: ['addiction_development'] },
  {
    id: 'progression',
    chapterId: 'ch3',
    coverageTopicIds: ['addiction_development', 'acting_out_patterns'],
  },
  {
    id: 'acting_out_examples',
    chapterId: 'ch3',
    coverageTopicIds: ['acting_out_patterns'],
    hasNudge: true,
  },
  {
    id: 'powerlessness_moment',
    chapterId: 'ch4',
    coverageTopicIds: ['powerlessness'],
    hasNudge: true,
  },
  {
    id: 'failed_stops',
    chapterId: 'ch4',
    coverageTopicIds: ['failed_stops', 'powerlessness'],
  },
  {
    id: 'unmanageability_overview',
    chapterId: 'ch5',
    coverageTopicIds: ['unmanageability'],
    hasNudge: true,
  },
  {
    id: 'relationships',
    chapterId: 'ch5',
    coverageTopicIds: ['relationships_impact', 'unmanageability'],
  },
  {
    id: 'consequences',
    chapterId: 'ch5',
    coverageTopicIds: ['consequences', 'unmanageability'],
  },
  {
    id: 'recent_episode',
    chapterId: 'ch5',
    coverageTopicIds: ['unmanageability', 'acting_out_patterns'],
  },
  { id: 'feelings', chapterId: 'ch5', coverageTopicIds: ['unmanageability'] },
  { id: 'bottom', chapterId: 'ch6', coverageTopicIds: ['bottom'] },
  { id: 'recovery_start', chapterId: 'ch6', coverageTopicIds: ['recovery_start', 'bottom'] },
  { id: 'closing', chapterId: 'ch7', coverageTopicIds: ['closing'] },
];

export function promptText(prompt: LifeStoryPrompt): string {
  return t(`step.1.prompts.${prompt.id}.text`);
}

export function promptPlaceholder(prompt: LifeStoryPrompt): string {
  return t(`step.1.prompts.${prompt.id}.placeholder`);
}

/** Hint shown below the prompt — empty when the prompt has none. */
export function promptNudge(prompt: LifeStoryPrompt): string {
  return prompt.hasNudge ? t(`step.1.prompts.${prompt.id}.nudge`) : '';
}

export function promptsForChapter(chapterId: Step1ChapterId): LifeStoryPrompt[] {
  return STEP1_LIFE_STORY_PROMPTS.filter((p) => p.chapterId === chapterId);
}

export function promptById(id: string): LifeStoryPrompt | undefined {
  return STEP1_LIFE_STORY_PROMPTS.find((p) => p.id === id);
}

export function chapterIndex(chapterId: Step1ChapterId): number {
  return STEP1_LIFE_STORY_PROMPTS.findIndex((p) => p.chapterId === chapterId);
}

export function globalPromptIndex(promptId: string): number {
  return STEP1_LIFE_STORY_PROMPTS.findIndex((p) => p.id === promptId);
}
